module.exports = {
    pendingClient: 'PENDING_CLIENT',
    pendingOps: 'PENDING_OPS',
    hidden: 'HIDDEN',
    fulfilled: 'FULFILLED'
};
